import { ReactComponent as IconSvg } from './icon_file_image.svg';
import Icon, { IconProps } from './icon';

const IconFileImage = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconFileImage;
